<template>
  <main class="service page-main">
    <section class="service-visual" data-style="show">
      <video
        muted
        loop
        autoplay
        playsinline
        poster="~@/static/image/service/pc/visual.jpg"
      >
        <source src="~@/static/video/service_visual.mp4" type="video/mp4">
        Sorry, your browser doesn't support embedded videos.
      </video>
    </section>

    <section class="page-heading-wrap">
      <h3 class="page-heading">{{ $t('service.head') }}</h3>
      <p class="page-heading-sub">{{ $t('service.subHead') }}</p>
      <html-view :value="$t('service.copy')" class="page-heading-desc" />
      <div class="app-download">
        <a href="https://apps.apple.com/kr/app/id378084485" target="_blank" class="btn btn-border">
          <icon-ios />
          IOS {{ $t('appDownload') }}
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.sampleapp" target="_blank" class="btn btn-border">
          <icon-android />
          Android {{ $t('appDownload') }}
        </a>
      </div>
    </section>

    <div>
      <tab
        :tab-list="tabList"
        :index="0"
        class="tab-sticky"
        @click:tab="onGoSticky"
      >
        <template v-slot:bar>
          <i class="tab-progress-bar" :style="`width: ${scrollPercentage}%`" />
        </template>
        <template v-slot:sub>
          <div v-if="$route.params.child === 'order'" class="tab-sub">
            <a :href="`#${$t('deliveryTakeaway.baeminOne.name')}`" @click="onGoAnchor">{{ $t('deliveryTakeaway.baeminOne.name') }}</a>
            <a :href="`#${$t('deliveryTakeaway.takeOut.name')}`" @click="onGoAnchor">{{ $t('deliveryTakeaway.takeOut.name') }}</a>
            <a :href="`#${$t('deliveryTakeaway.robots.name')}`" @click="onGoAnchor">{{ $t('deliveryTakeaway.robots.name') }}</a>
          </div>
        </template>
      </tab>
      <order id="order" class="sticky" />
    </div>

    <div>
      <tab
        :tab-list="tabList"
        :index="1"
        class="tab-sticky"
        @click:tab="onGoSticky"
      >
        <template v-slot:bar>
          <i class="tab-progress-bar" :style="`width: ${scrollPercentage}%`" />
        </template>
        <template v-slot:sub>
          <div class="tab-sub">
            <a :href="`#${$t('commerce.bMart.name')}`" @click="onGoAnchor">{{ $t('commerce.bMart.name') }}</a>
            <a :href="`#${$t('commerce.shoppingLive.name')}`" @click="onGoAnchor">{{ $t('commerce.shoppingLive.name') }}</a>
            <a :href="`#${$t('commerce.gifts.name')}`" @click="onGoAnchor">{{ $t('commerce.gifts.name') }}</a>
            <a :href="`#${$t('commerce.delicacies.name')}`" @click="onGoAnchor">{{ $t('commerce.delicacies.name') }}</a>
          </div>
        </template>
      </tab>
      <commerce id="commerce" class="sticky" />
    </div>

    <div>
      <tab
        :tab-list="tabList"
        :index="2"
        class="tab-sticky"
        @click:tab="onGoSticky"
      >
        <template v-slot:bar>
          <i class="tab-progress-bar" :style="`width: ${scrollPercentage}%`" />
        </template>
        <template v-slot:sub>
          <div class="tab-sub">
            <a :href="`#${$t('ceoAndRiders.ceo.name')}`" @click="onGoAnchor">{{ $t('ceoAndRiders.ceo.name') }}</a>
            <a :href="`#${$t('ceoAndRiders.mart.name')}`" @click="onGoAnchor">{{ $t('ceoAndRiders.mart.name') }}</a>
            <a :href="`#${$t('ceoAndRiders.kitchen.name')}`" @click="onGoAnchor">{{ $t('ceoAndRiders.kitchen.name') }}</a>
            <a :href="`#${$t('ceoAndRiders.connect.name')}`" @click="onGoAnchor">{{ $t('ceoAndRiders.connect.name') }}</a>
          </div>
        </template>
      </tab>
      <ceo id="ceo" class="sticky" />
    </div>

    <div>
      <tab
        :tab-list="tabList"
        :index="3"
        class="tab-sticky"
        @click:tab="onGoSticky"
      >
        <template v-slot:bar>
          <i class="tab-progress-bar" :style="`width: ${scrollPercentage}%`" />
        </template>
        <template v-slot:sub>
          <div v-if="$route.params.child === 'culture'" class="tab-sub">
            <a :href="`#${$t('culture.store.name')}`" @click="onGoAnchor">{{ $t('culture.store.name') }}</a>
            <a :href="`#${$t('culture.cartoon.name')}`" @click="onGoAnchor">{{ $t('culture.cartoon.name') }}</a>
          </div>
        </template>
      </tab>
      <culture id="culture" class="sticky" />
    </div>
  </main>
</template>

<script>
import observer from '@/mixins/observer'
import tabScrollbar from '@/mixins/tabScrollbar'
import contentsPage from '@/mixins/contentsPage'

export default {
  components: {
    iconIos: () => import('@/static/svg/ios.svg'),
    iconAndroid: () => import('@/static/svg/android.svg'),
    tab: () => import('@/components/base/Tab'),
    order: () => import('@/views/service/Order'),
    commerce: () => import('@/views/service/Commerce'),
    ceo: () => import('@/views/service/Ceo'),
    culture: () => import('@/views/service/Culture')
  },
  mixins: [observer, tabScrollbar, contentsPage],
  data () {
    return {
      tabList: [
        {
          params: { child: 'order' },
          name: 'menuService.deliveryTakeout'
        },
        {
          params: { child: 'commerce' },
          name: 'menuService.commerce'
        },
        {
          params: { child: 'ceo' },
          name: 'menuService.vendorsRiders'
        },
        {
          params: { child: 'culture' },
          name: 'menuService.culture'
        }
      ]
    }
  }
}
</script>
